export const ThemeList = {
  light: {
    // bgColors
    '--bg-color-modal3-before-select': '#FFFFFF',
    '--bg-color-modal3-after-select': '#EB6A5C',
    '--list-item-bg-color': '#FFFFFF',
    '--on-select-bg-color': 'rgba(178, 78, 67, 0.1)',
    '--primary-header-background-modal3': '#FFFFFF',
    '--primary-footer-background-modal3': ' #FAFAFA',
    '--primary-background': '#fafafa',
    '--primary-header-bg': '#ffffff',
    '--primary-elements-bg': '#efefef',
    '--primary-elements-bg-hover': '#f5f5f5',
    '--navigation-tree-bg': '#fafafa',
    '--dropdown-bg-selected': '#f6f6f6',
    '--element-bg-color-1': '#fafafa',
    '--input-group-background': '#3E3E3E',
    '--popover-bgColor': '#000',
    '--tooltip-bg': '#E7E7E7',
    '--success-background': '#F6F6F6',
    '--bin-bg': '#F6F6F6',
    '--modal2-content-color': '#F6F6F6',
    // '--background-selected': '#efefef',
    '--background-selected': '#e7e7e7',
    '--list-font-color': '#1B1B1B',
    // '--folder-bgcolor': '#7a7a7a',
    '--folder-bgcolor': '#F6F6F6',
    '--tooltip-font-color': '#232525',
    '--checkbox-bg': '#ffffff',
    '--button-background-1': '#fafafa',
    '--overlay-bg': '#e7e7e7',
    '--tree-active-node-bg': '#7a7a7a',
    '--neutral-50': '#fff',
    '--neutral-300': '#E7E7E7',
    '--modal-footer-background': '#FAFAFA',
    '--dropdown-search-option-bg': '#B24E431A',
    //End bgColors

    //Font Colors
    '--logs-category-font-modal3': '#7A7A7A',
    '--list-font-modal3': '#B5B5B5',
    '--font-modal3': '#7A7A7A',
    '--separator-color': '#e7e7e7',
    '--tooltip-font': '#1B1B1B',
    '--success-header': '#1B1B1B',
    '--success-body-font': "#7A7A7A",
    // '--primary-font-color': '#7a7a7a',
    '--primary-font-color': '#1b1b1b',
   '--primary-navbar-font-color':'#7a7a7a',
    '--secondary-font-color': '#b5b5b5',
    '--primary-font-color-selected': '#3e3e3e',
    '--input-box-font-color': '#000',
    '--header-basic-font': '#3e3e3e',
    '--button-gray-number': '#eee',
    '--help-link-color': '#6174F2',
    '--tree-active-node': '#fafafa',
    '--tree-node-font-color': '#7a7a7a',
    '--help-icon-container-color-selected': '#EB6A5C',
    '--selected-font-color': '#232525',
    '--modal-label-color': '#7a7a7a',
    '--dropdown-light-grey': '#7A7A7A',
    //End Font Colors

    //Buttons
    '--button-color-modal3-before-select': '#B5B5B5',
    '--button-color-modal3-after-select': '#FFFFFF',
    '--primary-style-color': '#EC7265',
    '--primary-style-color-trans': '#EC726533',
    '--primary-box-shadow': '#eb6a5c99',
    '--primary-style-shadow': 'rgba(235, 106, 92, 0.1)',
    '--input-progress-bar': '#d4d4d4',
    //End Buttons

    // Borders
    '--border-footer-modal3': '#E7E7E7',
    '--border-color-1': '#e7e7e7',
    '--tooltip-border': '#B5B5B5',
    '--input-box-border-1': 'none',
    '--input-box-border-2': '#B5B5B5',
    '--primary-shadow-color': '#E0E0E0',
    '--modal-background': 'rgba(0, 0, 0, 0.2)',
    '--box-shadow-primary': 'rgb(224, 224, 224)',
    '--help-modal-borderColor': '#e7e7e7',
    '--help-modal-dividerColor': '#f3f3f3',
    '--primary-pressed': '#B24E43',
    '--success-border-top': "#3E3E3E",
    '--success-box-shadow': "rgba(0, 0, 0, 0.25)",

    // images
    '--upload-asset-image': 'url(images/themes/light/upload_asset.svg)',
    '--icon-text-colored': 'url(images/themes/light/icon_text_colored.svg)',
    '--icon-rect': 'url(images/themes/light/rect.svg)',
    '--icon-circle': 'url(images/themes/light/circle.svg)',
    '--icon-star-empty': 'url(images/themes/light/star_empty.svg)',
    '--icon-line': 'url(images/themes/light/line.svg)',
    '--icon-path': 'url(images/themes/light/path.svg)',
    '--icon-trash-colored': 'url(images/themes/light/trash_red.svg)',
    '--icon-img-colored': 'url(images/themes/light/img.svg)',
    '--icon-edit-asset': 'url(images/themes/light/edit_asset.svg)',
    '--icon-play': 'url(images/themes/light/play.svg)',
    '--icon-pause': 'url(images/themes/light/pause.svg)',
    '--icon-hand': 'url(images/themes/light/hand.svg)',
    '--icon-comment_paint': 'url(images/themes/light/comment_paint.svg)',
    '--icon-comment_point': 'url(images/themes/light/comment_point.svg)',
    '--icon-360_flat': 'url(images/themes/light/360_flat.svg)',
    '--icon-360_spherical': 'url(images/themes/light/360_spherical.svg)',
    '--icon-speaker': 'url(images/themes/light/speaker_icon.svg)',
    '--icon-speaker-muted': 'url(images/themes/light/speaker_icon_muted.svg)',
    '--loop-back': 'url(images/themes/light/loop_back.svg)',
    '--icon_radio_checked': 'url(images/themes/light/icon_radio_checked.svg)',
    '--icon_radio_unchecked': 'url(images/themes/light/icon_radio_unchecked.svg)',
    '--icon-header-close': 'url(images/themes/light/close_dark.svg)',
    '--icon-hiphen-allFiles': 'url(images/themes/light/hiphen_light.svg)'
  },
  dark: {
    // bgColors
    '--bg-color-modal3-before-select': '#1B1B1B',
    '--bg-color-modal3-after-select': '#FAD923',
    '--list-item-bg-color': '#1B1B1B',
    '--on-select-bg-color': '#483d0445',
    '--primary-header-background-modal3': '#1B1B1B',
    '--primary-footer-background-modal3': ' #3E3E3E',
    '--primary-background': '#2d2f2f',
    '--primary-header-bg': '#1b1b1b',
    '--checkbox-bg': '#232525',
    '--primary-elements-bg': '#3e3e3e',
    '--primary-elements-bg-hover': '#3a3a3a',
    '--navigation-tree-bg': '#232525',
    '--dropdown-bg-selected': '#232525',
    '--element-bg-color-1': '#1b1b1b',
    '--input-group-background': '#3e3e3e00',
    '--popover-bgColor': '#fff',
    '--tooltip-bg':'#3E3E3E',
    '--success-background': '#232525',
    '--bin-bg': '#232525',
    // '--background-selected': '#b5b5b5',
    '--background-selected': '#3e3e3e',
    '--list-font-color': '#1b1b1b',
    // '--folder-bgcolor': '#3e3e3e',
    '--folder-bgcolor': '#232525',
    '--tooltip-font-color': '#f6f6f6',
    '--button-background-1': '#262727',
    '--overlay-bg': '#2D2F2F',
    '--tree-active-node-bg': '#b5b5b5',
    '--neutral-50': '#1B1B1B',
    '--neutral-300': '#3E3E3E',
    '--modal-footer-background': '#2D2F2F',
    '--dropdown-search-option-bg': '#947D001A',
    '--modal2-content-color': '#232525',
    //End bgColors

    //Font Colors
    // '--primary-font-color': '#b5b5b5',
    '--primary-navbar-font-color':'#B5B5B5',
    '--logs-category-font-modal3': '#B5B5B5',
    '--list-font-modal3': '#7A7A7A',
    '--font-modal3': '#B5B5B5',
    '--primary-font-color': '#f6f6f6',
    '--tooltip-font': '#F6F6F6',
    '--primary-font-color-selected': '#efefef',
    '--secondary-font-color': '#7a7a7a',
    '--separator-color': '#3e3e3e',
    '--input-box-font-color': '#fff',
    '--header-basic-font': '#e7e7e7',
    '--button-gray-number': '#2d2f2f',
    '--selected-font-color': '#f6f6f6',
    '--help-link-color': '#80B2FF',
    '--tree-active-node': '#2D2F2F',
    '--tree-node-font-color': '#b5b5b5',
    '--help-icon-container-color-selected': '#FAD923',
    '--modal-label-color': '#b5b5b5',
    '--dropdown-light-grey': '#b5b5b5',
    '--success-header': '#F6F6F6',
    '--success-body-font': "#7A7A7A",
    //End Font Colors

    //Buttons
    '--button-color-modal3-before-select': '#7A7A7A',
    '--button-color-modal3-after-select': '#1B1B1B',
    '--primary-style-color': '#fad923',
    '--primary-style-color-trans': '#fad92333',
    '--primary-box-shadow': '#f0eb6099',
    '--primary-style-shadow': 'rgba(250, 217, 35, 0.1)',
    '--input-progress-bar': '#2d2f2f',
    //End Buttons

    //Borders
    '--border-footer-modal3': '#3E3E3E',
    '--border-color-1': '#1b1b1b',
    '--tooltip-border': '#7A7A7A',
    '--input-box-border-1': '1px solid #7a7a7a',
    '--input-box-border-2': '#7a7a7a',
    '--primary-shadow-color': '#232525',
    '--modal-background': 'rgba(0, 0, 0, 0.5)',
    '--box-shadow-primary': 'rgb(0, 0, 0, 0.3)',
    '--help-modal-borderColor': '#3e3e3e',
    '--help-modal-dividerColor': '#3d3d3d',
    '--primary-pressed': '#947D00',
    '--success-border-top': "#3E3E3E",
    '--success-box-shadow': "rgba(0, 0, 0, 0.25)",
    // images
    '--upload-asset-image': 'url(images/themes/dark/upload_asset.svg)',
    '--icon-text-colored': 'url(images/themes/dark/icon_text_colored.svg)',
    '--icon-rect': 'url(images/themes/dark/rect.svg)',
    '--icon-circle': 'url(images/themes/dark/circle.svg)',
    '--icon-star-empty': 'url(images/themes/dark/star_empty.svg)',
    '--icon-line': 'url(images/themes/dark/line.svg)',
    '--icon-path': 'url(images/themes/dark/path.svg)',
    '--icon-trash-colored': 'url(images/themes/dark/trash_red.svg)',
    '--icon-img-colored': 'url(images/themes/dark/img.svg)',
    '--icon-edit-asset': 'url(images/themes/dark/edit_asset.svg)',
    '--icon-play': 'url(images/themes/dark/play.svg)',
    '--icon-pause': 'url(images/themes/dark/pause.svg)',
    '--icon-hand': 'url(images/themes/dark/hand.svg)',
    '--icon-comment_paint': 'url(images/themes/dark/comment_paint.svg)',
    '--icon-comment_point': 'url(images/themes/dark/comment_point.svg)',
    '--icon-360_flat': 'url(images/themes/dark/360_flat.svg)',
    '--icon-360_spherical': 'url(images/themes/dark/360_spherical.svg)',
    '--icon-speaker': 'url(images/themes/dark/speaker_icon.svg)',
    '--icon-speaker-muted': 'url(images/themes/dark/speaker_icon_muted.svg)',
    '--loop-back': 'url(images/themes/dark/loop_back.svg)',
    '--icon_radio_checked': 'url(images/themes/dark/icon_radio_checked.svg)',
    '--icon_radio_unchecked': 'url(images/themes/dark/icon_radio_unchecked.svg)',
    '--icon-header-close': 'url(images/themes/dark/close_white.svg)',
    '--icon-hiphen-allFiles': 'url(images/themes/dark/hiphen_dark.svg)'
  }
};
